import { Button } from "../../../../components/Button";
import { ReactComponent as CallIcon } from "../../../../assets/icons/call.svg";
import { ReactComponent as LocationIcon } from "../../../../assets/icons/location.svg";
import { ReactComponent as StarIcon } from "../../../../assets/icons/star.svg";
import { ReactComponent as LeftIcon } from "../../../../assets/icons/chevron-left.svg";

import { TABS } from "./Tabs";
import { Tabs } from "../../UserTabs";

export function Banner({
  userType,
  details,
  onDeactivate,
  onDelete,
  user,
  onReview,
  onUpdate,
}) {
  return (
    <div>
      {/** banner */}

      <div className="w-[898px] flex-col justify-start items-start gap-3 flex relative mb-16">
        <div className="w-full h-[160px]">
          <img
            src={details?.coverImg || "/beautifi-banner.png"}
            className="w-full h-full rounded-[20px] object-cover"
            alt="banner"
          />
        </div>
        <div className="absolute left-10 h-[110px] w-[110px] border-[3px] border-white rounded-full -bottom-[55px]">
          <img
            src={details?.profileImg || "/profile.jpeg"}
            className="w-full h-full rounded-full object-fill"
            alt="user"
          />
        </div>
        <div className="absolute left-40 right-10 -bottom-12 flex justify-between">
          {userType === Tabs.Salons && (
            <button
              type="button"
              onClick={onReview}
              className="pl-[9px] pr-2 py-1.5 bg-[#fff4ec] rounded-md items-center gap-[3px] flex"
            >
              <StarIcon className="w-4 h-4" />
              <div className="text-black text-sm font-normal mt-0.5 poppins leading-[21px]">
                {user?.rating}({user?.totalReviews})
              </div>
              <LeftIcon className="w-3.5 h-3.5" />
            </button>
          )}
          {userType === Tabs.Stylists ? (
            <div>
              {details?.salon?.fullName && (
                <div className="pl-1.5 pr-[18px] py-1.5 bg-[#fff1f1] rounded-[40px] justify-start items-center gap-1 inline-flex">
                  <img
                    className="w-[23px] h-[23px] rounded-full border border-white"
                    src={details?.salon?.profileImg || "/profile.jpeg"}
                    alt="salon"
                  />
                  <div className="opacity-60 text-black text-sm font-normal poppins leading-[21px]">
                    Works in {details?.salon?.fullName}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div />
          )}
          <div>
            <div className="items-center gap-4 flex">
              <Button
                variant="link"
                className="text-right !text-[#444444] text-sm font-medium poppins"
                onClick={onUpdate}
              >
                Update user
              </Button>
              <div className="h-3.5 w-[1px] bg-black/20" />
              <Button
                variant="link"
                className="text-right !text-[#444444] text-sm font-medium poppins"
                onClick={onDeactivate}
              >
                Deactivate user
              </Button>
              <div className="h-3.5 w-[1px] bg-black/20" />
              <Button
                variant="link"
                className="text-right !text-[#d54949] text-sm font-medium poppins"
                onClick={onDelete}
              >
                Delete user
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/** Intro */}
      <div className="flex-col justify-start items-start gap-3 flex mx-10 mb-7">
        <div className="flex-col justify-center items-start gap-0.5 flex">
          <div className="text-black text-xl font-semibold poppins leading-[30px]">
            {details?.fullName}
          </div>
          <div className="justify-start items-center gap-3 inline-flex">
            <div className="opacity-60 text-black text-sm font-normal poppins leading-[21px]">
              @{details?.username}
            </div>
            {details?.mobile &&
              [Tabs.Stylists, Tabs.Salons].includes(userType) && (
                <>
                  <div className="h-3.5 w-[1px] bg-black/20" />
                  <div className="justify-start items-center gap-1 flex">
                    <CallIcon />
                    <div className="opacity-60 text-black text-sm font-normal poppins leading-[21px]">
                      {details?.mobile}
                    </div>
                  </div>
                </>
              )}
            {details?.address && userType === Tabs.Salons && (
              <>
                <div className="h-3.5 w-[1px] bg-black/20" />
                <div className="justify-start items-start gap-1 flex">
                  <LocationIcon className="w-[18px] h-[18px]" />
                  <div className="max-w-[350px] overflow-hidden whitespace-nowrap text-ellipsis opacity-60 text-black text-sm font-normal poppins leading-[21px]">
                    {details?.address}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="self-stretch opacity-60 text-black text-sm font-normal poppins">
          {details?.aboutMe}
        </div>
      </div>
    </div>
  );
}
